import type { SessionTokens } from "@/stores/companion-store";

interface RuntimeIdentity {
  runtimeSessionId?: string;
  conversationId?: string;
}

export function inputBarConversationIdentity<T extends RuntimeIdentity>(
  activeRuntime: T | undefined,
  tokenSnapshot: SessionTokens | undefined,
): RuntimeIdentity {
  if (activeRuntime) {
    return {
      runtimeSessionId: activeRuntime.runtimeSessionId,
      conversationId: activeRuntime.conversationId,
    };
  }
  return {
    runtimeSessionId: tokenSnapshot?.runtimeSessionId,
    conversationId: tokenSnapshot?.conversationId,
  };
}
